import React from 'react';
import PropTypes from 'prop-types';

import {
    onShowEmailInterstitial,
    onGoToNextCard,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import EmailInterstitial from '../../components/EmailInterstitial/EmailInterstitialPopup';

import { TransitionGroup } from 'react-transition-group';
import CssTransition from '../../components/Transition/CssTransition';

import AnswerButton from '../../components/Assessment/AnswerButton';

import { connect } from 'react-redux';
import { onAnswerClick } from './actions';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';

import {
    SingleAction,
    parseSingleActionProps,
    requiredFunctionsForSingleAction
} from '../SingleAction/SingleActionDetails';

class QuizDetails extends SingleAction {
    buttonComponent() {
        return (
            <AutoScalingButtonSet
                isMobile={this.props.isMobile}
                isVisualLink={this.props.isVisualLink}
            >
                {this.props.answers.map(a => (
                    <AnswerButton
                        longText={this.props.longText}
                        key={a.id}
                        text={a.text}
                        textUppercase={this.props.makeUppercase}
                        useLoadingSpinner={true}
                        onClick={() => {
                            this.props.setExitingCardProps(
                                'quiz',
                                this.props,
                                this.props.activeAction
                            );

                            const nextAction = getNextAction(
                                this.props.allWidgetActions,
                                this.props.activeAction.identifier,
                                this.props.conditionalActionsAnswerHistory.concat([{
                                    actionIdentifier: this.props.activeAction.identifier,
                                    answerId: a.id
                                }]),
                                this.props.cards
                            );
                            if (this.props.skipEndCard) {
                                this.props.handleSkippingEndCard(
                                    nextAction,
                                    this.props.cards,
                                    this.props.onGoToNextCard
                                );
                            }
                            this.props.onAnswerClick(
                                this.props.apiRequestData,
                                a.id,
                                a.text,
                                this.props.actionIdentifier,
                                this.props.actionCompletedTime(),
                                this.props.isMultiActionsCard,
                                this.props.answers,
                                this.props.feedbackText,
                                this.props.showEmailInterstitial,
                                this.props.onShowEmailInterstitial,
                                this.props.widgetId,
                                this.props.cardTitle,
                                this.props.skipEndCard,
                                this.props.actionInitiated
                            );
                        }}
                    />
                ))}
            </AutoScalingButtonSet>
        );
    }

    overlayComponents() {
        return (
            <TransitionGroup>
                {this.props.emailInterstitialVisibility && (
                    <CssTransition key="alert" in={this.props.onShowEmailInterstitial}>
                        <EmailInterstitial />
                    </CssTransition>
                )}
            </TransitionGroup>
        );
    }
}

QuizDetails.propTypes = {
    ...SingleAction.propTypes,
    activeAction: PropTypes.object.isRequired,
    allWidgetActions: PropTypes.array.isRequired,
    widgetId: PropTypes.string.isRequired,
    cardTitle: PropTypes.string.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    answers: PropTypes.array.isRequired,
    onAnswerClick: PropTypes.func.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    actionCompletedTime: PropTypes.func.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    feedbackText: PropTypes.string,
    makeUppercase: PropTypes.bool.isRequired,
    longText: PropTypes.bool.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    onShowEmailInterstitial: PropTypes.func.isRequired,
    emailInterstitialVisibility: PropTypes.bool.isRequired,
    showEmailInterstitial: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    onGoToNextCard: PropTypes.func.isRequired,
    handleSkippingEndCard: PropTypes.func.isRequired,
    skipEndCard: PropTypes.bool,
    nextAction: PropTypes.object,
    cards: PropTypes.array.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'quiz',
            ['/quiz', '/quiz/start'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const conditionalActionsAnswerHistory = buildConditionalActionsAnswerHistory(state);
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            conditionalActionsAnswerHistory,
            state.widget.cards
        );

        return {
            ...parseSingleActionProps(state),
            allWidgetActions: state.widget.actions,
            nextAction,
            isMobile: state.widget.isMobile,
            widgetId: state.widget.widgetRequestId,
            actionIdentifier: state.widget.activeAction.identifier,
            answers:
                state.widget.activeAction.possibleAnswers !== undefined
                    ? state.widget.activeAction.possibleAnswers.slice(0, 4)
                    : [],
            apiRequestData: state.widget.apiRequestData,
            actionCompletedTime: getActionCompletedTime(state, 'quiz'),
            conditionalActionsAnswerHistory,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            feedbackText: state.widget.activeAction.feedbackText,
            makeUppercase: (state.widget.activeAction.possibleAnswers || []).every(
                a => a.text.length <= 8
            ),
            longText: (state.widget.activeAction.possibleAnswers || []).some(
                a => a.text.length >= 20
            ),
            actionInitiated: state.quiz.actionInitiated,
            emailInterstitialVisibility: state.widget.showEmailInterstitial || false,
            showEmailInterstitial: state.widget.activeAction.collectEmail > 0,
            cards: state.widget.cards,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction,
            cardTitle: state.widget.activeAction.name,
            cardDescription: state.widget.activeAction.description || ''
        };
    },
    {
        ...requiredFunctionsForSingleAction,
        onAnswerClick,
        onShowEmailInterstitial,
        onGoToNextCard,
        setExitingCardProps,
        handleSkippingEndCard
    }
)(QuizDetails);
